import { formatCurrency, formatYear } from "@app/utils";
import { UsePlanSummary } from "../planSummary/usePlanSummary";
import {
  CarDisclosureContentCode,
  UseDisclosures,
} from "@app/hooks/useDisclosures";
import { PdfReportPage, PdfReportPageProps } from "./PdfReportPage";
import { CarPdfSubHeading } from "@app/components/PdfHeading";
import { CarPdfMarkdown } from "@app/components/PdfMarkdown";
import {
  CarPdfIconFailure,
  CarPdfIconPartial,
  CarPdfIconSuccess,
} from "@app/components/PdfIcon";
import { CarPdfBox } from "@app/components/PdfBox";
import { CarPdfTypography } from "@app/components/PdfTypography";
import {
  CarPdfHeader,
  CarPdfHeaderCell,
  CarPdfRow,
  CarPdfTable,
  CarPdfTextCell,
  CarPdfViewCell,
} from "@app/components/PdfTable";
import { CarPdfGoalsLegend } from "./PdfGoalsLegend";

export interface GoalsPdfPageProps {
  pageProps: PdfReportPageProps;
  planSummary: UsePlanSummary;
  disclosures: UseDisclosures;
}

export const GoalsPdfPage = (props: GoalsPdfPageProps) => {
  return (
    <PdfReportPage {...props.pageProps}>
      <CarPdfSubHeading label="Goals" />
      <CarPdfMarkdown style={{ marginTop: 10, marginBottom: 30 }}>
        {props.disclosures.getContent(
          CarDisclosureContentCode[
            "CMPAS_CLIENT_REPORT_SUMMARY:_GOALS_part_10"
          ],
        )}
      </CarPdfMarkdown>
      <CarPdfTable colWidths={[1.8, 0.8, 1, 1, 1.5, 1.2]}>
        <CarPdfHeader paddingVertical={14}>
          <CarPdfHeaderCell>Goal Name (Priority)</CarPdfHeaderCell>
          <CarPdfHeaderCell>Status</CarPdfHeaderCell>
          <CarPdfHeaderCell>Start</CarPdfHeaderCell>
          <CarPdfHeaderCell>End</CarPdfHeaderCell>
          <CarPdfHeaderCell>*Annual Amount</CarPdfHeaderCell>
          <CarPdfHeaderCell>*Total</CarPdfHeaderCell>
        </CarPdfHeader>
        {props.planSummary.goals.map((i, idx) => (
          <CarPdfRow key={idx} paddingVertical={10}>
            <CarPdfTextCell
              style={{
                textAlign: "left",
                paddingHorizontal: 5,
              }}
            >
              {i.nameWithPriority}
            </CarPdfTextCell>
            <CarPdfViewCell
              style={{
                justifyContent: "center",
                alignItems: "center",
                paddingVertical: 0,
              }}
            >
              {i.status === "success" ? (
                <CarPdfIconSuccess />
              ) : i.status === "failure" ? (
                <CarPdfIconFailure />
              ) : (
                <CarPdfIconPartial />
              )}
            </CarPdfViewCell>
            <CarPdfTextCell>{formatYear(i.startDate)}</CarPdfTextCell>
            <CarPdfTextCell>{formatYear(i.endDate)}</CarPdfTextCell>
            <CarPdfTextCell>{formatCurrency(i.annualAmount)}</CarPdfTextCell>
            <CarPdfTextCell>
              {formatCurrency(i.totalAmountBeforeInflation)}
            </CarPdfTextCell>
          </CarPdfRow>
        ))}
      </CarPdfTable>
      <CarPdfBox style={{ height: 10 }} />
      <CarPdfTypography
        variant="disclosures"
        style={{ width: "100%", textAlign: "right" }}
      >
        *Amounts are represented in today’s dollars (pre-inflation).
      </CarPdfTypography>
      <CarPdfGoalsLegend
        style={{
          marginTop: 20,
        }}
      />
    </PdfReportPage>
  );
};
